import { render, staticRenderFns } from "./TaxRow.vue?vue&type=template&id=18664ea3&scoped=true&"
import script from "./TaxRow.vue?vue&type=script&lang=js&"
export * from "./TaxRow.vue?vue&type=script&lang=js&"
import style0 from "./TaxRow.vue?vue&type=style&index=0&id=18664ea3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18664ea3",
  null
  
)

export default component.exports